import { CommanderActionTypesEnum } from '@spazious/dollhouse-commander';
import { getShallowNodeValue } from '@spazious/dollhouse-shallow-graph';
import { useGraph, useStaging, useStore } from '@spazious/dollhouse-store';
import { Flex, FlexProps, Switch, Typography } from '@spazious/dollhouse-uikit';

import { useNodesPlacementValidator, useSelectedNodes } from '../../hooks/index.js';

import { Grid } from './Grid.js';

export interface BooleanFieldProps extends Omit<FlexProps, 'defaultValue'> {
  icon?: React.ReactNode;
  path: string;
  meta?: CommanderActionTypesEnum;
  disabled?: boolean;
  defaultValue?: boolean;
}

export const BooleanField: React.FC<BooleanFieldProps> = ({
  icon,
  path,
  meta = CommanderActionTypesEnum.Param,
  disabled,
  defaultValue,
  ...restProps
}) => {
  const { update } = useStaging();
  const staging = useStore(({ staging }) => staging);
  const selectedNodes = useSelectedNodes();
  const { graph } = useGraph();
  const { validator } = useNodesPlacementValidator(selectedNodes);

  return (
    <Grid {...restProps}>
      {icon && (
        <Typography
          size="large"
          style={{
            padding: 8,
            color: 'gray',
            userSelect: 'none',
          }}
          variant="label"
        >
          {icon}
        </Typography>
      )}
      <Flex alignItems="center" minWidth="100px">
        <Switch
          checked={getShallowNodeValue(selectedNodes[0], path)}
          defaultChecked={defaultValue}
          disabled={disabled}
          type="checkbox"
          onChange={(evt) => {
            selectedNodes.forEach(
              (node) => node.selector && update(node.selector, path, evt.target.checked)
            );
            graph.once('update', () => {
              if (validator()) {
                staging.commit(meta);
              } else {
                staging.abort();
              }
            });
          }}
        />
      </Flex>
    </Grid>
  );
};
